import Link from "next/link";
import { useTranslations } from "next-intl";
import TickIcon from "@/assets/icons/tick.svg";
import { buttonVariants } from "@/components/ui/button";
import {
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { getLocaleForPathname, getPathname } from "@/i18n/navigation";
import { cn } from "@/lib/utils";

export const LocalizerStatusSuccess = ({
  postCode,
  city,
}: {
  postCode: string;
  city: string;
}) => {
  const t = useTranslations("localizer");
  const locale = getLocaleForPathname();

  const pathname = getPathname({
    href: { pathname: "/diets" },
    locale,
  });

  return (
    <DialogContent className="max-w-[calc(100%-2rem)] rounded-xl sm:max-w-[500px]">
      <DialogHeader className="mb-6">
        <DialogTitle className="-mb-1 text-left font-medium text-xl md:text-2xl">
          {t("success.title")}
        </DialogTitle>
        <DialogDescription className="font-bold text-2xl text-primary">
          {t("success.description")}
        </DialogDescription>
      </DialogHeader>
      <div className="mb-2 flex items-center gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-brand-green-300/95 md:h-11 md:w-11">
          <TickIcon className="text-white" />
        </div>
        <p className="font-medium text-lg md:text-xl">
          <span>{postCode}</span> <span>{city}</span>
        </p>
      </div>
      <p className="text-lg opacity-45 md:text-xl">{t("positive.info")}</p>
      <DialogFooter className="mt-6">
        <Link
          href={pathname}
          className={cn(
            buttonVariants({ variant: "secondary" }),
            "h-14 w-full",
          )}
        >
          {t("success.button")}
        </Link>
      </DialogFooter>
    </DialogContent>
  );
};
